<template>
    <transition name="slide">
        <nav class="mobile p-3" v-if="visible">
            <slot></slot>
        </nav>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
            }
        },
        methods: {
            //
        },
        mounted() {
            this.eventHub.$on('toggleMobileMenu', () => {
                this.visible = !this.visible;
            });
        },
    }
</script>
